/**
 * The field a panel list endpoint is asked to sort on.
 *
 * The list APIs sort on `createdOn`. `updatedOn` and `lastModifiedOn` are not
 * fields they can sort by, so a column showing the update stamp still sorts —
 * by creation time. Applied where the request is built, so the table keeps its
 * own column key and the sort arrow stays on the column that was clicked.
 */
export const apiSortField = (field: string): string =>
  field === "updatedOn" || field === "lastModifiedOn" ? "createdOn" : field;
